import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './material.css'
import './../../css/nike.css'
import Sofive from './../../images/sofive.png'
import Scoreplay from './../../images/scoreplay.png'

class Intro extends Component {
  render() {
    return (
      <div>
        <div className="row valign-wrapper" style={{ height: '20vh' }}>
          <div className="col s3 center-align">
          </div>
          <div
            className="col s6 center-align txt"
            style={{ fontSize: '14vh', lineHeight: 1 }}
          >
            {this.props.half_time
              ? 'Half-Time'
              : this.props.start && this.props.start}
          </div>
          <div className="col s3 center-align">
          </div>
        </div>
        {!this.props.half_time && (
          <div
            className="row stripe valign-wrapper"
            style={{
              height: '50vh',
            }}
          >
            <div
              className="col s12 center-align txt"
              style={{ fontSize: '25vh', lineHeight: 1, color: '#d5e710' }}
            >
              {this.props.description.replace("-", " ")}
            </div>
          </div>
        )}
        <div className="row valign-wrapper" style={{ height: '20vh' }}>
          <div
            className="col s12 center-align txt"
            style={{ fontSize: '12vh', lineHeight: 1 }}
          >
            {this.props.league.replace("-", " ")}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Intro)
)
